import { Action, createReducer, on } from '@ngrx/store';
import * as AddServicesToContractsWizardActions from './actions';
import { State, initialState } from './state';

export const addServicesToContractsWizardFeatureKey = 'addServicesToContractsWizardV26';

const addServicesToContractsWizardReducer = createReducer(
  initialState,

  on(AddServicesToContractsWizardActions.selectServices, (state, { servicesStep }) => ({
    ...state,
    servicesStep,
  })),
  on(AddServicesToContractsWizardActions.selectContracts, (state, { contractsStep }) => ({
    ...state,
    contractsStep,
  })),
  on(AddServicesToContractsWizardActions.exitAddServicesToContractsWizard, (state) => ({
    ...state,
    servicesStep: null,
    contractsStep: null,
    errorMessage: null,
    request: null,
    response: null,
  })),
  on(AddServicesToContractsWizardActions.destroyWizard, (state) => ({
    ...state,
    servicesStep: null,
    contractsStep: null,
    errorMessage: null,
    request: null,
    response: null,
  })),
  on(AddServicesToContractsWizardActions.createNewAddServicesToContracts, (state, { request }) => ({
    ...state,
    request,
  })),
  on(AddServicesToContractsWizardActions.createNewAddServicesToContractsSuccess, (state, { response }) => ({
    ...state,
    response,
  })),
  on(AddServicesToContractsWizardActions.createNewAddServicesToContractsFail, (state, { errorMessage }) => ({
    ...state,
    errorMessage,
  })),
);

export function reducer(state: State | undefined, action: Action) {
  return addServicesToContractsWizardReducer(state, action);
}
